import { debug } from '../lib/general';
import { clearSavedOrderState } from '../lib/stateStorage';
import { useAppStore } from './useAppStore';

export const usePurchaseActions = () => {
    const qrCode = useAppStore((s) => s.qrCode);

    const onRepeatPurchaseClickHandler = (page = ''): void => {
        if (!qrCode) {
            debug(`repeatPurchase: qrCode is not defined, page: ${page}`, 'warn');
        }
        clearSavedOrderState();
        const qrParam = qrCode ? `?qr=${qrCode}` : '';
        debug(`repeat purchase click - on page: ${page}\nqr: ${qrParam}`, 'info');
        window.location.href = `/${qrParam}`;
    };

    return {
        onRepeatPurchaseClickHandler,
    };
};
